import React, { useEffect, useState } from 'react';
import { ArrowUp } from '@phosphor-icons/react';

export const BackToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;
  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="Back to top"
      data-testid="back-to-top"
      className="fixed bottom-6 right-6 z-[60] inline-flex items-center gap-1.5 bg-gray-900 hover:bg-[#FF6B35] text-white px-4 py-2.5 rounded-full shadow-2xl text-xs font-bold uppercase tracking-wider transition-all hover:-translate-y-0.5"
    >
      <ArrowUp size={14} weight="bold" /> Top
    </button>
  );
};
